import React, { useState, useEffect } from "react";
import { RiArrowDropDownLine } from "react-icons/ri";
import HeadingArea from '../../general/HeadingArea';
import axios from 'axios'
import ResponseMsg2 from '../../general/ResponseMsg2';
import { AiOutlineSearch } from 'react-icons/ai';
import { FaCheck } from 'react-icons/fa';


const ExamAttendance = ({ setLoading }) => {

  const [selectedExam, setSelectedExam] = useState("");
  const [selectedExamDetailId, setSelectedExamDetailId] = useState('');
  const [selectedSection, setSelectedSection] = useState("");
const [isExistingAttendance, setIsExistingAttendance] = useState(false);


  //updated
  const [response2, setResponse2] = useState({ message: '', status: 'success' });
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAY, setSelectedAY] = useState('');
  const [classes, setClasses] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');

  const [subjects, setSubjects] = useState([]);
  const [exam, setExam] = useState([]);
  const [attendanceData, setAttendanceData] = useState({});
  const [showMark, setShowMark] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [student, setStudent] = useState([]);
    const [assignedSubjects, setAssignedSubjects] = useState([]);
 
  const [form, setForm] = useState({
    examType: '',
    class_name: '',
    section: '',
    year: '',
    subject: '',
    examMarks: '',
    total: '',

  })




  useEffect(() => {

    fetchClasses();
    fetchAcademicYears();
    fetchSubjects();
    fetchExamTypeDetail();
   

  }, [])


  const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-academic-years');
      if (response.ok) {
        const data = await response.json();
        setAcademicYears(data);
      } else {
        console.error('Failed to fetch academic years');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };



  const fetchSubjects = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-subjects');

      if (response.ok) {
        const data = await response.json();
        setSubjects(data);
        setLoading(false);
      } else {
        setLoading(false);
        console.error('Failed to fetch class');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  }


  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');

      if (response.ok) {
        const data = await response.json();
        setClasses(data);
        setLoading(false);


      } else {
        setLoading(false);
        console.error('Failed to fetch class');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error fetching data:', error);
    }
  }
  useEffect(() => {
    if (selectedClassId) {
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      if (selectedClass && selectedClass.sections) {
        const sectionArray = selectedClass.sections
          .split(',')
          .map((s) => s.trim())
          .filter((s) => s !== '');
        setAvailableSections(sectionArray);
      } else {
        setAvailableSections([]);
      }
      setSelectedSection('');
    } else {
      setAvailableSections([]);
      setSelectedSection('');
    }
  }, [selectedClassId, classes]);

  const fetchExamTypeDetail = async () => {
    setLoading(true)
    try {
      const res = await axios.get('https://api.kcian.in/fetch-exam-type');
      setExam(res.data);

      setLoading(false);
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'class_name') {
      const selectedClass = classes.find((cls) => cls.id.toString() === value);
      setForm((prev) => ({
        ...prev,
        class_name: selectedClass
          ? { classId: selectedClass.id, className: selectedClass.class_name }
          : '',
      }));
    } else if (name === 'examType') {
      const selectedExam = exam.find((ex) => ex.id.toString() === value);
      setForm((prev) => ({
        ...prev,
        examType: selectedExam
          ? { examTypeId: selectedExam.id, examTypeName: selectedExam.exam_name }
          : '',
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


const handleSaveOrUpdateAttendance = async () => {
  const monthName = new Date(selectedDate).toLocaleString('default', { month: 'long' });

  const payload = student.map((student) => ({
    studentId: student.id,
    class_name: selectedClassName,
    section: selectedSection,
    exam_date: selectedDate,
    exam_month: monthName,
    mark: attendanceData[student.id]?.attendance || 'Present',
    note: attendanceData[student.id]?.note || '',
    ay: selectedAY,
    exam_type_id: selectedExamDetailId
  }));

  setLoading(true);

  try {
    if (isExistingAttendance) {
      // Update API
      await axios.put('https://api.kcian.in/update-exam-attendance', payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      setResponse2({ message: 'Attendance updated successfully!', status: 'success' });
    } else {
      // Save API
      await axios.post('https://api.kcian.in/save-exam-attendance', payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      setResponse2({ message: 'Attendance saved successfully!', status: 'success' });
    }

    setTimeout(() => setResponse2({ message: '', status: '' }), 2000);
    setIsExistingAttendance(true);
  } catch (error) {
    console.error('Error saving/updating attendance:', error);
    setResponse2({ message: 'Something went wrong!', status: 'error' });
  } finally {
    setLoading(false);
  }
};






  const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
  const selectedClassName = selectedClass ? selectedClass.class_name : '';

  const handleSearch = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {

      // Get class_name from classId
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      const className = selectedClass ? selectedClass.class_name : '';

      const selectedExamType = exam.find((e) => e.id === Number(selectedExam));
      const examName = selectedExamType ? selectedExamType.exam_name : '';


      const selectedSubject = form.subject;
      const selectedSubjectName = subjects.find(
        (e) => String(e.id) === String(selectedSubject)
      );
      const subName = selectedSubjectName ? selectedSubjectName.sub_name : '';
      console.log("Selected subject name:", subName);


      // Build query params
      const params = new URLSearchParams();
      params.append('ay', selectedAY);
      params.append('class_name', className);
      params.append('examType', examName);
      params.append('sub_name', subName);
      console.log(subName);

      if (selectedSection) {
        params.append('section', selectedSection);
      }

      const url = `https://api.kcian.in/get-exam-attendence?${params.toString()}`;
      console.log('Request URL:', url);
      const response = await axios.get(url);

      if (response.data.length === 0) {
        console.log('No data found')
        setResponse2({ message: 'No Exam Scheduled.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);
      } else {
        console.log('data found....', response.data);
        setSelectedExamDetailId(response.data[0].id);
        const params = new URLSearchParams();
        params.append('ay', selectedAY);
        params.append('class_name', className);

        if (selectedSection) {
          params.append('section', selectedSection);
        }

        const url = `https://api.kcian.in/get-student?${params.toString()}`;
        console.log('Request URL:', url);
        const myResponse = await axios.get(url);

        if (myResponse.status === 200) {
          const data = myResponse.data;
          setStudent(data);
          const defaultAttendance = {};
          data.forEach((student) => {
            defaultAttendance[student.id] = {
              attendance: 'Present',
              note: ''
            };
          });


           const attendanceResponse = await axios.get(`https://api.kcian.in/get-student-exam-attendance/${response.data[0].id}`);
    if (attendanceResponse.data && attendanceResponse.data.length) {
      attendanceResponse.data.forEach(record => {
        defaultAttendance[record.student_id] = {
          attendance: record.mark || 'Present',
          note: record.note || ''
        };
      });
          setIsExistingAttendance(true);
    }  else {
        setIsExistingAttendance(false);
    }
          setAttendanceData(defaultAttendance);
        } else {
          console.error('Failed to fetch students');
        }
      }

    } catch (error) {
      console.error('Error fetching students:', error);
          setIsExistingAttendance(false);
    } finally {
      setLoading(false);
    }
  };

   const fetchAssignSubject = async (classId = selectedClassId, section = selectedSection) => {
        console.log('function call')
        if (!classId || !section) {
            // setResponse2({ message: 'Please select class and section before searching', status: 'error' });
            return;
        }

        try {
            setLoading(true);
            const res = await fetch(`https://api.kcian.in/fetch-assigned-subject?class_id=${classId}&section=${section}`);

            const data = await res.json();
            console.log(data);

            if (res.ok) {
                if (data.length > 0) {
                    setAssignedSubjects(data);
                    setResponse2({ message: 'Assigned Subjects Fetched Successfully', status: 'success' });
                } else {

                    setAssignedSubjects([])
                    setResponse2({ message: 'No Subjects Assigned for this Class & Section.', status: 'error' });
                }
            } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
            }
        } catch (error) {
            console.error('Fetch assigned subjects error:', error);
        } finally {
            setLoading(false);
            setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
        }
    };


  return (
            <section className='py-4'>

    <div className="px-4">
      <HeadingArea message1="Exam" message2="Exam Attendance" />

      <form onSubmit={handleSearch} className='profile-card'>
        <span className="profile-heading">Select Criteria</span>

        <div className='row mt-3'>

          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className='profile-input-area'>
              <label className="profile-badge">Select AY*</label>
              <select
                className="profile-input"
                value={selectedAY}
                onChange={(e) => setSelectedAY(e.target.value)}
                required
              >
                <option value="">-- Select Academic Year --</option>
                {academicYears.map((ay) => (
                  <option key={ay.year} value={ay.year}>
                    {ay.year} --- {ay.title}
                  </option>
                ))}
              </select>
            </div>
          </div>


          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className='profile-input-area'>
              <label className="profile-badge">Select Class*</label>
              <select
                className="profile-input"
                value={selectedClassId}
                onChange={(e) => setSelectedClassId(e.target.value)}
                required
              >
                <option value="">-- Select Class --</option>
                {classes.map((cls) => (
                  <option key={cls.id} value={cls.id}>
                    {cls.class_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

         

          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className='profile-input-area'>
              <label className="profile-badge">Select Section*</label>
              <select
                className="profile-input"
                value={selectedSection}
                // onChange={(e) => setSelectedSection(e.target.value)}
                 onChange={(e) => {
                  const value = e.target.value;
                  setSelectedSection(value);
                  fetchAssignSubject(selectedClassId, value); // Pass the new section value
                }}
                disabled={availableSections.length === 0}
                required
              >
                <option value="">-- Select Section --</option>
                {availableSections.map((section, idx) => (
                  <option key={idx} value={section}>
                    {section}
                  </option>
                ))}
              </select>
            </div>
          </div>
           <div className="col-lg-3 col-md-6 col-6 mb-4">

            <div className='profile-input-area '>
              <label className='profile-badge'>Subject*</label>
              <select name='subject' value={form.subject}
                onChange={handleChange}
                className='profile-input' required>
                <option value=''>--- Select ---</option>
                {/* {subjects.map((sub, index) => (
                  <option key={index} value={sub.id}>{sub.sub_name}</option>
                ))} */}
                {assignedSubjects.map((sub, index) => (
                  <option key={index} value={sub.sub_id}>
                    {sub.sub_name}
                  </option>
                ))}

              </select>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className='profile-input-area '>
              <label className='profile-badge'>Exam Type</label>
              <select
                className='profile-input'
                name='examType'
                value={selectedExam}
                onChange={(e) => setSelectedExam(e.target.value)}

                required
              >
                <option value=''>Select Type</option>
                {exam.map((type, index) => (
                  <option key={type.id} value={type.id}>
                    {type.exam_name}
                  </option>
                ))}
              </select>

            </div>
          </div>

          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className='profile-input-area'>
              <label className="profile-badge">Select Date*</label>
              <input
                type="date"
                className="profile-input"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                required
              />
            </div>
          </div>


        </div>
        {/* flex ends */}


        <div className='text-end'>
          <button type='submit' className='profile-btn2'>
            <AiOutlineSearch /> Search
          </button>
        </div>
      </form>


      <div className='profile-card mt-3'>
        <span className="profile-heading">Exam Attendance | Class: {selectedClassName}, Section: {selectedSection}, Date: {selectedDate}</span>
        {/* Render student list here */}

        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

        <br />

        {/* {student.length != 0 &&
          <>
            {showMark && (
              <>
                <p className='fw-semibold mt-2'>Want to mark Today as Holiday?</p>
                <button className='profile-btn me-2' onClick={() => handleSaveAttendance('Holiday')}>Yes</button>
                <button className='profile-btn2' onClick={() => setShowMark(false)}>No</button>
              </>
            )}
          </>
        } */}

        <div className='table-responsive my-3'>
          <table className='w-100'>

            <thead className='account-thead'>
              <th className='rounded-start-4'>Roll No</th>
              <th>Name</th>
              <th>Reg No</th>
              <th>Attendance</th>
              <th className='rounded-end-4'>Note</th>
            </thead>

            {student.length === 0 ? (
              <tr className='text-center account-tr'><td colSpan={8}>No Student Data found</td></tr>
            ) : (
              <>
                {student.map((student) => (
                  <tr className='account-tr' key={student.id}>
                    <td>{student.roll_no}</td>
                    <td>{student.name}</td>
                    <td>{student.reg_no}</td>
                    <td>
                      <div className='d-flex gap-2'>
                        {['Present', 'Absent', 'Leave'].map((status) => (
                          <label key={status}>
                            <input
                              type="radio"
                              name={`attendance-${student.id}`}
                              value={status}
                              checked={attendanceData[student.id]?.attendance === status}
                              onChange={() =>
                                setAttendanceData((prev) => ({
                                  ...prev,
                                  [student.id]: {
                                    ...prev[student.id],
                                    attendance: status,
                                  },
                                }))
                              }
                            />{' '}
                            {status}
                          </label>
                        ))}
                      </div>
                    </td>

                    <td>
                      <div className='profile-input-area'>
                        <input
                          type="text"
                          placeholder="Add Note Here"
                          className="profile-input"
                          value={attendanceData[student.id]?.note || ''}
                          onChange={(e) =>
                            setAttendanceData((prev) => ({
                              ...prev,
                              [student.id]: {
                                ...prev[student.id],
                                note: e.target.value,
                              },
                            }))
                          }
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </>
            )}
          </table>
        </div>

<div className='text-center'>
  <button className='profile-btn' onClick={handleSaveOrUpdateAttendance}>
    <FaCheck /> {isExistingAttendance ? 'Update Attendance' : 'Save Attendance'}
  </button>
</div>

      </div>



    </div>
    </section>
  )
}

export default ExamAttendance